import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution, UserView } from 'cb-model';
import { TaskDefinition } from 'gossamer-model';

export interface InstitutionMemberInviteRow {
  id: number;
  institution_id: number;
  invitee_email: string;
  is_admin: boolean;
  invited_by: string;
  created_at: string;
  institution_group_ids?: string | null;
  registration_task_definition_id?: number;
}

export const InstitutionMemberInvite: Entity<InstitutionMemberInviteRow> = {
  id: 'InstitutionMemberInvite',
  title: 'Institution Invite',
  service: 'main',
  rowLabel: (row: InstitutionMemberInviteRow) => row.invitee_email,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_member_invite',
  },
  security: [
    { role: 'admin', action: 'all', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['invitee_email', 'ASC']],
  defaultFilters: [{ fieldId: 'invitee_email', operator: 'sw', value: '' }],
  listRowLink: '/admin/institution-member/display-invite/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    invitee_email: {
      seq: 10,
      type: FieldType.Text,
      label: 'Email Address',
      mandatory: true,
      listColumn: true,
      formColumnWidths: { xs: 12, lg: 6 },
    },
    institution_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Institution',
      mandatory: true,
      refEntity: Institution,
    },
    is_admin: {
      seq: 20,
      type: FieldType.Boolean,
      label: 'Invite as Admin?',
    },
    invited_by: {
      seq: 25,
      type: FieldType.Reference,
      label: 'Invited By',
      refEntity: UserView,
      formColumnWidths: { xs: 12, lg: 6 },
      listColumn: true,
    },
    created_at: {
      seq: 30,
      label: 'Invited At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    institution_group_ids: {
      seq: 35,
      type: FieldType.Text,
      label: 'Group',
      description:
        'Id(s) of Group(s) to Add this Member to (if they accept the invite). Must be a list of numbers separated by the "|" character',
      regex: '^[\\d|]+$',
    },
    registration_task_definition_id: {
      seq: 40,
      type: FieldType.Reference,
      label: 'Registration Task Definition',
      refEntity: TaskDefinition,
    },
  },
};
